import React,{useState, useEffect} from 'react';
import './App.css';


//router
import { BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';


import TopBar from './TopBar';
import AnimatedRoutes from './AnimatedRoutes';



function App(){


  return (
    
      
      <div className="App">
      
        <Router>
          {/* <Redirects /> */}
          <TopBar />
          <AnimatedRoutes />
        </Router>

      </div>
    
  );
}

export default App;
